export default class nivelIncidenciaService {

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/nivel-incidencia',
			"id": '/api/nivel-incidencia/:id',
			"new": '/api/nivel-incidencia',
			"update": '/api/nivel-incidencia',
			'delete': '/api/nivel-incidencia/:id'
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
        if(typeof data.objeto_ubicacion !== 'undefined' && data.objeto_ubicacion.nombre == 'Bodega') {
        	delete data.ubicacion.posicion;
            delete data.ubicacion.direccion;
            delete data.ubicacion.sitio;
            delete data.ubicacion.tramo;
        } else if(typeof data.objeto_ubicacion !== 'undefined') {
            delete data.ubicacion.area;
            delete data.ubicacion.sector;
        }
		return this.http.post(url, data);
	}

	delete(objId){
		let idRoute = this.routes.delete.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.delete(url);
	}

	update(data){
		let url = this.baseUrl + this.routes.update;
        if(typeof data.objeto_ubicacion !== 'undefined' && data.objeto_ubicacion.nombre == 'Bodega') {
            delete data.ubicacion.posicion;
            delete data.ubicacion.direccion;
            delete data.ubicacion.sitio;
            delete data.ubicacion.tramo;
        } else if(typeof data.objeto_ubicacion !== 'undefined') {
            delete data.ubicacion.area;
            delete data.ubicacion.sector;
        }
		return this.http.put(url, data);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/nivelIncidenciaService.js